<div #chipElement (click)="active()" class="chip"
    [ngClass]="{'checked': control.value, 'disabled': disabled, 'danger': isDanger}" *ngIf="control">
    <ng-content></ng-content>
    <input #chipCheck type="checkbox" hidden="hidden" [value]="control.value" [attr.name]="name" [attr.id]="id"
        [formControl]="control" [checked]="control.value" />
</div>